'use client';
import React from 'react';

export default function CTABanner() {
  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#2c2c2c',
        padding: '20px',
        borderBottom: '2px solid #3b3b3b',
      }}
    >
      <div
        style={{
          maxWidth: '740px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '16px',
          fontWeight: 900,
          fontFamily: '"Open Sans", sans-serif',
        }}
      >
        <div>
          <p
            style={{
              fontSize: 'clamp(20px, 3vw, 31px)',
              color: '#fff',
              margin: '5px 0 0',
              textTransform: 'uppercase',
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: 900,
            }}
          >
            Cost-Effective Printers&apos; Services
          </p>
        </div>
        <div>
          <a
            href="mailto:gottschprisupport@gottschpri.com"
            style={{
              display: 'inline-block',
              marginTop: '5px',
              backgroundColor: '#fff',
              color: '#0e6585',
              border: '2px solid #fff',
              borderRadius: '12px',
              padding: '12px 20px',
              fontFamily: 'Lato, sans-serif',
              fontWeight: 700,
              fontSize: '12px',
              textTransform: 'uppercase',
              textDecoration: 'none',
              letterSpacing: '0.5px',
              transition: 'all 0.2s',
            }}
            className="cta-email-btn"
          >
            Email Us
          </a>
        </div>
      </div>
      <style jsx>{`
        .cta-email-btn:hover {
          background-color: transparent !important;
          color: #fff !important;
        }
      `}</style>
    </div>
  );
}
